export const SITE_ID_QUERY_PARAM = 'site_id';

export const parseSiteId = (search?: string): number | undefined => {
  const source =
    search ?? (typeof window !== 'undefined' ? window.location.search : '');
  const raw = new URLSearchParams(source).get(SITE_ID_QUERY_PARAM);
  if (!raw) return undefined;

  const siteId = Number(raw);
  return Number.isInteger(siteId) && siteId > 0 ? siteId : undefined;
};

export const withSiteId = (target: string, siteId?: number): string => {
  const origin =
    typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
  const url = new URL(target, origin);

  if (siteId) {
    url.searchParams.set(SITE_ID_QUERY_PARAM, String(siteId));
  } else {
    url.searchParams.delete(SITE_ID_QUERY_PARAM);
  }

  return `${url.pathname}${url.search}${url.hash}`;
};
